<mat-card appearance="outlined" style="max-height: 70vh; min-height: 60vh;  width: 70vw; display: flex;">
    <mat-card-content class="no-title" style="display: flex; flex: 1">
      <ng-container *ngIf="data.isHTML">
        <iframe [srcdoc]="data.text" style="flex:1; border: none; min-height: max-content;" (click)="$event.preventDefault()">  </iframe>
      </ng-container>
      <ng-container *ngIf="!data.isHTML">
        <div [innerText]="data.text">

        </div>
      </ng-container>
    </mat-card-content>
  
      <mat-dialog-actions>
        <button mat-stroked-button class="cancel" (click)="onCancel()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
      </mat-dialog-actions>
  </mat-card>
